import React from "react";
import { TouchableOpacity, View } from "react-native";
import { NormalText } from "../../../../common/native";
import { MockScenarioKey, MockScenarioOption } from "./mockMetadata";

type MockModePanelProps = {
  scenarioOptions: MockScenarioOption[];
  selectedMockScenario: MockScenarioKey;
  setSelectedMockScenario: (key: MockScenarioKey) => void;
};

const MockModePanel: React.FC<MockModePanelProps> = ({
  scenarioOptions,
  selectedMockScenario,
  setSelectedMockScenario,
}) => {
  return (
    <View
      style={{
        marginHorizontal: 20,
        marginBottom: 10,
        borderWidth: 1,
        borderColor: "#D0D5DD",
        borderRadius: 10,
        padding: 10,
        backgroundColor: "#F8FAFC",
        gap: 8,
      }}
    >
      <NormalText
        text="Test mode enabled (`?test=1`). Select a mock metadata shape; Generate will skip API calls."
        style={{ color: "#344054", fontSize: 13 }}
      />
      <View style={{ flexDirection: "row", gap: 8, flexWrap: "wrap" }}>
        {scenarioOptions.map((option) => {
          const isSelected = selectedMockScenario === option.key;
          return (
            <TouchableOpacity
              key={option.key}
              onPress={() => setSelectedMockScenario(option.key)}
              style={{
                borderWidth: 1,
                borderColor: isSelected ? "#00B7F4" : "#D0D5DD",
                backgroundColor: isSelected ? "#E6F7FD" : "#FFFFFF",
                borderRadius: 8,
                paddingVertical: 8,
                paddingHorizontal: 10,
              }}
            >
              <NormalText
                text={option.label}
                style={{
                  fontSize: 12,
                  color: isSelected ? "#026AA2" : "#344054",
                }}
              />
              <NormalText
                text={option.description}
                style={{ fontSize: 11, color: "#667085", maxWidth: 280 }}
              />
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
};

export default MockModePanel;
